// extracted by mini-css-extract-plugin
export default {"documentDownloadWrapper":"styles_documentDownloadWrapper__kSwu2","documentInfo":"styles_documentInfo__0p2Co","documentDownloadButton":"styles_documentDownloadButton__KC5hc"};